module.exports = __webpack_public_path__ + "img/2025-07_student_experience.c418a4e2.webp";